import {
    trackClickIBubbleAcceptingNewPatients,
    trackClickIBubbleGeisingerHealthPlanExtra,
    trackClickIBubbleHandicapAccessible,
    trackClickIBubblePatientAgeRestrictions,
    trackClickIBubbleProvenHealthNavigatorLocation,
    trackClickIBubbleTier,
    trackClickIBubbleWheelchairAccessible,
} from './actions';

export const mapDispatchToProps = {
    trackClickIBubbleAcceptingNewPatients,
    trackClickIBubbleGeisingerHealthPlanExtra,
    trackClickIBubbleHandicapAccessible,
    trackClickIBubblePatientAgeRestrictions,
    trackClickIBubbleProvenHealthNavigatorLocation,
    trackClickIBubbleTier,
    trackClickIBubbleWheelchairAccessible,
};
